module.exports = __webpack_public_path__ + "img/img_lianghua_ai@3x.2d3b90dd.png";